import DataTable, { createTheme } from "react-data-table-component";
import { useState,useEffect,useMemo, Fragment } from "react";

import MoreVert from '@mui/icons-material/MoreVert';
import { ManageSearchRounded,Clear,Print } from "@mui/icons-material";
import { CircularProgress, IconButton, Skeleton } from "@mui/material";
import { EneaButton,tablestyle,modalstyle,parseToLink,dateSort,concurrecySort } from "./Style";
import { TextField } from "@mui/material";
import { blue,blueGrey,green } from "@mui/material/colors";
import { Backdrop,Fade, Modal,Box,Typography} from "@mui/material";
import { Button } from "@mui/material";
import { EsitiCard } from "./EsitiCard";
import { Divider, Grid2 } from '@mui/material';
import ENEAlogo from './ENEAlogo';

import { ENEA_GEST_API_URL } from './Statics';

const baseurl= ENEA_GEST_API_URL;
//const baseurl = "https://dati.enea.it/gest/catalog/"
const esitiurl = baseurl+"esiti";


// https://react-data-table-component.netlify.app/?path=/story/custom-styles-compact-grid--compact-grid&globals=backgrounds.grid:!false

createTheme(
	'ENEA',
	{
		text: {
			primary: blue[900],
			secondary: blue[900],
		},
		background: {
			default: '#ffffff',
		},
		context: {
			background: blue[900],
			text: '#aaaaaa',
		},
		divider: {
			default: blue[200],
		},
		button: {
      default: blue[800],
			hover: 'rgba(0,0,0,.08)',
			focus: 'rgba(255,255,255,.12)',
			disabled: 'rgba(255, 255, 255, .34)',
		},
		sortFocus: {
			default: blue[800],
		},
	},
);

var arr_fields = {
  'dt_inizio': 'Data Inizio',
  'CIG': 'CIG',
  'oggetto_appalto': 'Oggetto Appalto',
  'procedura_nome': 'Procedura',
  'aggiudicatario': 'Aggiudicatario',
  'importo_aggiudicazione': 'Importo netto',
  'dettagli': 'Scheda dettaglio'
  };




const TableEsiti =({showid,mindate,maxdate})=>{

    const [json,setJson]=useState([]);
    const [busy,setBusy]=useState(false);
    const [page,setPage]=useState(0);
    const [details,setDetails]=useState();
    const [detailsurl,setDetailsUrl]=useState();
    const [openDetails,setShowDetails]=useState(false);
    const [filterText,setFilterText]=useState('');
    const [find,setFind]=useState([]);
    const [fetching,setFetching] = useState("");

    /* Search */
    useEffect(()=>{
      console.log("search on esiti "+filterText);
          
    },[filterText])
        
    const subHeaderComponentMemo = () => {
      const handleClear = () => {
            setFilterText("");
      };
      const handleChange = (val) => {
        setFilterText(val);
      };
    
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ManageSearchRounded sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
          <TextField fullWidth 
                  size="small" 
                  variant='outlined' 
                  value={filterText} 
                  label="Ricerca full-text" 
                  onChange={(e)=>handleChange(e.target.value)}/>
          <IconButton aria-label="clear" aria-roledescription="clear button" sx={{color:blue[800]}} onClick={()=>handleClear()}>
            <Clear/>
          </IconButton>
        </Box>
        );
    };
    
    /*const detailCard = useEffect(() =>{
      if(details!==undefined)
        return(<EsitiCard 
          detail={details}
          handleclose={()=>setShowDetails(false)} 
        />)
    },[details]);*/

    const getDetail = (url)=>{
      //setBusy(true);
      fetch(url,{
          method:'GET'
      }).then(resp=>resp.json())
        .then(j=>{
          //setBusy(false);
          if(j.length>0){
            setDetails(j[0]);
            setDetailsUrl(url);
            setShowDetails(true);    
          }else{
            console.log("too much elements "+j);
          }
        }
      ).catch(err=>{console.log("err")})
    }

    const columns = [{
      name:<Typography variant="body2">Data inizio</Typography>,
      selector: row => new Date(row.dt_inizio).toLocaleDateString()||'-',
      sortable: true,
      sortFunction: (a,b)=>{
        return new Date(a.dt_inizio)-new Date(b.dt_inizio);
      },
      width:"130px",
  },
  {
      name: <Typography variant="body2">CIG</Typography>,
      selector: row => row.CIG.toUpperCase(),
      sortable: true,
      width:"130px",
  },
  {
      name: <Typography variant="body2">Oggetto appalto</Typography>,
      selector: row => row.oggetto_appalto,
      sortable: true,
      grow:true,
      wrap:true,
      minWidth:"200px",
  },
  {
      name: <Typography variant="body2">Procedura</Typography>,
      selector: row => row.procedura_nome,
      grow:true,
      wrap:true,
      sortable: true,
      minWidth:"200px",
  },
  {
      name: <Typography variant="body2">Aggiudicatario</Typography>,
      selector: row => row.aggiudicatario,
      grow:true,
      wrap:true,
      sortable: true,
      maxWidth:"240px",
  },
  {
    name: <Typography variant="body2">Importo netto</Typography>,
    selector: row => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(row.importo_aggiudicazione),
    sortable: true,
    sortFunction: (a,b)=>a.importo_aggiudicazione-b.importo_aggiudicazione,
    grow:true,
    minWidth:"170px",
  },
  {
    name: <Typography variant="body2">Dettagli</Typography>,
    selector: row => {
          return (
            <Fragment>
            <IconButton aria-label="detail" aria-roledescription="get details" sx={{textWrap:'auto',color:blue[800]}} onClick={
              ()=>getDetail(parseToLink(row.dettaglio))
              }>
              <MoreVert/><Typography variant="body2" component="span">apri dettagli</Typography>
            </IconButton>
            </Fragment>
          );
      },
    sortable: false,
    grow:true,
    
    minWidth:"150px",
  },
  
  ]
  
  /* filter effect */
  useEffect(()=>{
    //let rex = filterText.trim().replace(" ",".+");
    if(filterText.length>0){
      let regex = new RegExp(filterText.trim().replaceAll(" ",".+"), "i");
      const find = json.filter( singlerow => {
        return Object.values(singlerow).filter( v => {
          if(typeof v === 'string' || v instanceof String)  
            return v.match(regex)!==null;
          return false;
        }).length>0
      }).map( o =>o);
      setFind(find);
    }else{
      setFind(json);
    }
  },[json,filterText]);

  

  const myfetch = (url,startyear,arraydest,stopyear,cb)=>{
        let turl = new URL(url);
        
        if((startyear!==undefined)&&(startyear!==0)){
          turl.searchParams.set("dt_inizio",startyear);
        } else{
          turl.searchParams.set("dt_inizio",2025);
        }
        fetch(turl,{
          method:'GET'
        }).then(resp=>resp.json())
        .then(j=>{
          arraydest.push(j.data);
          setBusy(false);
          setJson(arraydest.flatMap(o=>o));
          if(startyear>(stopyear+1)){
            myfetch(url,startyear-1,arraydest,stopyear,cb);
            setPage(j.current_page+1);
            setFetching("Righe per pagina");
          } else {
            cb(j);
            setFetching("in caricamento...");
          }
        }).catch(err=>{
          setBusy(false);
          console.log(err)
        })
      };
      
      useEffect(()=>{
        const url = new URL(esitiurl+"/search");
        //url.searchParams.set("page",1);
        let starty = new Date().getFullYear();
        let stopy = 2017;
        if(maxdate!==undefined){
          starty=new Date(maxdate).getFullYear();
        } 
        if(mindate!==undefined){
          stopy=(new Date(mindate).getFullYear())-1;
        }
        url.searchParams.set("dt_inizio",starty);
        url.searchParams.set("per_page",99999);
        console.log("esiti dw");
        setBusy(true);
        if(showid!==''){
          getDetail(parseToLink('/api/v1/esiti/'+showid));
        }else{
          myfetch(url,starty,[],stopy,()=>{
            console.log("Esiti finsh");
          });
        }
      },[]);

      

    return (
      <Fragment role="main">
        {showid==='' && (<DataTable 
                  className="to-screen"
                  customStyles={tablestyle} 
                  highlightOnHover 
                  subHeader 
                  subHeaderComponent={subHeaderComponentMemo()} 
                  persistTableHead 
                  theme="ENEA" 
                  progressPending={busy}  
                  progressComponent={
                    <p><CircularProgress/></p>
                  }
                  ariaLabel="esiti" 
                  columns={columns} 
                  data={find} 
                  paginationComponentOptions={{
                    rowsPerPageText: "Righe per pagina",
                  }}
                  pagination />)}
       {details!==undefined && (
        <Modal
          aria-labelledby="modal-detail-title"
          aria-describedby="modal-detail-description"
          open={openDetails}
          onClose={()=>setShowDetails(false)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
            timeout: 500,
          },
          
        }}
        >
          <Fade in={openDetails}>
          <Box sx={{ ...modalstyle, width: '88%', overflowY:'visible' }}>
            <Grid2 container sx={{justifyContent: "space-between",alignItems: "center",}} columns={2}>
              <Grid2 size={1}>
              
              <Typography variant="h1" sx={{fontSize:36}} id="modal-detail-title">
                <ENEAlogo/>
                  Scheda di dettaglio esito {details.id}
                </Typography>
              </Grid2>
              <Grid2 size={1} sx={{width:"fit-content"}} >
                <IconButton title="stampa scheda" ariaLabel="stampa scheda" color="primary" onClick={()=>{
                    window.print();
                  }
                  }>
                  <Print sx={{width:50,height:50}} />
                  </IconButton>
                  {showid==='' && (<IconButton title="chiudi scheda" ariaLabel="chiudi scheda" color="primary" onClick={()=>setShowDetails(false)}>
                    <Clear sx={{width:50,height:50}} />
                  </IconButton>)}
              </Grid2>
              <Grid2 size={2}>
                <Typography variant="h2" sx={{fontSize:24}} component="div" id="modal-detail-description" >
                  {details.oggetto_appalto}
                
                </Typography>
              </Grid2>
            </Grid2>
            
            <EsitiCard 
              showclose={showid===''}
              detailurl={detailsurl}
              detail={details}
              handleclose={()=>setShowDetails(false)} 
            />
          </Box>  
          </Fade>
        </Modal>
      )}
      </Fragment>
      )
}

export default TableEsiti;